import request from '@/utils/request.js'
import web from '@/utils/web.js'
// 左侧菜单
// GET /sys/menu/nav
export const getMenu = () => request({
    url: '/edge-admin/sys/menu/nav',
    method: 'get',
    params: {
    }
})
// 登录
export const login = (username, password, captcha, uuid) => {
    return request.post(web.base + '/login', {
        username, password, captcha, uuid
    })
}
// 项目管理列表
export const systemManagementList = (page, limit, projectName) => request({
    url: web.base + '/project/page',
    method: 'get',
    params: {
        page, limit, projectName
    }
})
// 项目名称列表
export const getXmList = () => request({
    url: web.base +'/project/listAll',
    method: 'get',
    params: {
    }
})
// 项目管理新增
export const add = (row) => {
    return request.post(web.base +'/project/save', 
        row
    )
}
// 删除
export const del = (ids) => {
    return request.post(web.base +'/project/delete', ids
        
    )
}
// 修改
export const updateItem1 = (form) => {
    return request.post(web.base +'/project/update', form
    )
}



// 网关管理列表
export const getWgList = (page, limit, projectId, gatewayCode) => request({
    url: web.base +'/gateway/page',
    method: 'get',
    params: {
        page, limit, projectId, gatewayCode
    }
})
// 网关列表新增
export const addWgList = (row) => {
    return request.post(web.base +'/gateway/save', 
        row
    )
}
// 网关列表删除
export const delWgList = (ids) => {
    return request.post( web.base +'/gateway/delete', ids  
    )
}
// 网关修改
export const updateWgItem = (form) => {
    return request.post(web.base +'/gateway/update', form
    )
}
export const getWgContent = (id) => request({
    url: web.base +`/gateway/${id}`,
    method: 'get'
})
export const getWgDown = (id) => request({
    url: web.base +`/gateway/publishData/${id}`,
    method: 'get'
})


// 通道列表
export const getTdList = (page, limit, channelName, gatewayId) => request({
    url: web.base +'/channel/page',
    method: 'get',
    params: {
        page, limit, channelName, gatewayId
    }
})
export const getTdAll = (channelType,gatewayId) => request({
    url: web.base +`/channel/listAll`,
    method: 'get',
    params: {
        channelType, gatewayId
    }
})
// 通道列表添加
export const addTdList = (row) => {
    return request.post(web.base +'/channel/save', 
        row
    )
}
export const getTdList1 = (page, limit, channelName, gatewayId) => request({
    url: web.base +'/channel/zfChannel',
    method: 'get',
    params: {
        page, limit, channelName,gatewayId
    }
})

// 通道列表删除
export const delTdList = (ids) => {
    return request.post(web.base +'/channel/delete', ids  
    )
}
// 通道列表修改
export const updateTdItem = (form) => {
    return request.post(web.base +'/channel/update', form
    )
}


// 设备管理列表页
export const getSbList = (page, limit, channelId, branchName, gatewayId,channelType) => request({
    url: web.base +'/branch/page',
    method: 'get',
    params: {
        page, limit, channelId, branchName, gatewayId, channelType
    }
})
export const getSbListAll = (channelId,gatewayId,channelType) => request({
    url: web.base +`/branch/listByChannelId/${channelId}/${gatewayId}/${channelType}`,
    method: 'get',
    params: {
    }
})
// 设备管理添加
export const addSbList = (row) => {
    return request.post(web.base +'/branch/save', 
        row
    )
}
// 设备管理删除
export const delSbList = (ids) => {
    return request.post(web.base +'/branch/delete', ids  
    )
}
// 设备管理修改
export const updateSbItem = (form) => {
    return request.post(web.base +'/branch/update', form
    )
}

// 采集点管理列表页
export const getCTagList = (page, limit, channelId, branchId, tagType, tagName, gatewayId, channelType) => request({
    url: web.base +'/tag/page',
    method: 'get',
    params: {
        page, limit, channelId, branchId, tagType, tagName, gatewayId, channelType
    }
})
export const getTagListAll = (channelType) => request({
    url: web.base + `/tag/listAll${channelType}`,
    method: 'get',
    params: {
    }
})
// 采集点管理添加
export const addTagList = (row) => {
    return request.post(web.base +'/tag/save', 
        row
    )
}
// 采集点管理删除
export const delTagList = (ids) => {
    return request.post(web.base +'/tag/delete', ids  
    )
}
// 采集点管理修改
export const updateTagItem = (form) => {
    return request.post(web.base +'/tag/update', form
    )
}

// 用户信息
export const getUser = () => request({
    url: web.base +'/sys/user/info',
    method: 'get',
    params: {
    }
})
// 用户列表 --------------------------------------------------------------------------------------------------
export const getUserInfo = (page,limit,username) => request({
    url: web.base +'/sys/user/page',
    method: 'get',
    params: {
        page,limit,username
    }
})
// 新增
export const addUser = (row) => {
    return request.post(web.base +'/sys/user', 
        row
    )
}
// 部门列表
// GET /sys/dept/list
export const getDept = () => request({
    url: web.base +'/sys/dept/list',
    method: 'get',
    params: {
    }
})
// 角色id列表
export const getRole = () => request({
    url: web.base +'sys/role/list',
    method: 'get',
    params: {
    }
})
// 用户管理删除
export const delUser = (ids) => {
    return request.post(web.base +'/sys/user/delete', ids
    )
}
export const updateUser = (row) => {
    return request.put(web.base +'/sys/user', row
    )
}
export const getUserinfo1 = (ids) => request({
    url: web.base + `/sys/user/${ids}`,
    method: 'get'
})
// 部门管理 -------------------------------------------------------------------------------
// 列表
// GET /sys/dept/list
export const getDeptList = () => request({
    url: web.base + '/sys/dept/list',
    method: 'get',
    params: {
    }
})
// POST /sys/dept
// 新增
export const addDept = (row) => {
    return request.post(web.base +'/sys/dept', row
    )
}
// 修改
export const updateDept = (row) => {
    return request.put(web.base +'/sys/dept', row
    )
}
// POST /sys/dept/delete
// 删除
// export const delDept = (id) => {
//     return request.post('/edge-admin/sys/dept/delete', {id}
//     )
// }
export const delDept = (id) => request({
    url: web.base +`/sys/dept/delete/${id}`,
    method: 'get'
})
// 角色管理 --------------------------------------------------------------------------------------
// 列表
// GET /sys/role/page
export const getRoleList = (page, limit, name) => request({
    url: web.base +'/sys/role/page',
    method: 'get',
    params: {
        page, limit, name
    }
})
// 菜单授权
// GET /sys/menu/select
export const getmenuselectList = () => request({
    url: web.base +'/sys/menu/select',
    method: 'get',
    params: {
    }
})
// 保存
// POST /sys/role
export const addRole = (row) => {
    return request.post('/edge-admin/sys/role', row
    )
}
// 删除
// POST /sys/role/delete
export const delRole = (ids) => {
    return request.post(web.base +'/sys/role/delete', ids
    )
}
// 获取当前行详细数据
// GET /sys/role/{id}
export const getRoleinfo = (ids) => request({
    url: web.base +`/sys/role/${ids}`,
    method: 'get'
})
// 编辑
export const updateRole = (row) => {
    return request.put(web.base +'/sys/role', row
    )
}
// 菜单管理 --------------------------------------------------------------------------------------
// GET /sys/menu/list
// 列表
export const getmenuList = () => request({
    url: web.base +'/sys/menu/list',
    method: 'get',
    params: {
    }
})
// 当前行数据
// GET /sys/menu/{id}
export const getMenuinfo = (ids) => request({
    url: web.base +`/sys/menu/${ids}`,
    method: 'get'
})
// 保存
// POST /sys/menu
export const addMenu = (row) => {
    return request.post(web.base +'/sys/menu', row
    )
}
// 修改
// PUT /sys/menu
export const updateMenu = (row) => {
    return request.put(web.base +'/sys/menu', row
    )
}
// 删除
// POST /sys/menu/delete
export const delMenu = (id) => request({
    url: web.base +`/sys/menu/delete/${id}`,
    method: 'get'
})
// 参数管理 -------------------------------------------------------------------------------------------
// GET /sys/params/page
// 列表
export const getParamsList = (page, limit, paramCode) => request({
    url: web.base +'/sys/params/page',
    method: 'get',
    params: {
        page, limit, paramCode
    }
})
// 新增
// POST /sys/params
export const addParams = (row) => {
    return request.post(web.base +'/sys/params', row
    )
}
// 编辑
export const UpdateParams = (row) => {
    return request.put(web.base +'/sys/params', row
    )
}
// 删除
// POST /sys/params/delete
export const delParams = (ids) => {
    return request.post(web.base +'/sys/params/delete', ids
    )
}


// 修改密码
// PUT /sys/user/password
export const UpdatePassword = (newPassword, password) => {
    return request.put(web.base +'/sys/user/password', {newPassword, password}
    )
}
// 字典管理 ------------------------------------------------------------------------------------------------】、
// GET /sys/dict/page
export const getDictList = (page, limit, dictType, dictName, pid) => request({
    url: web.base +'/sys/dict/page',
    method: 'get',
    params: {
        page, limit, dictType, dictName, pid
    }
})
// 新增
// POST /sys/dict
export const addDict = (row) => {
    return request.post(web.base +'/sys/dict', row
    )
}
// 修改
export const updateDict = (row) => {
    return request.put(web.base +'/sys/dict', row
    )
}
// 删除
// POST /sys/dict/delete
export const deldict = (ids) => {
    return request.post(web.base +'/sys/dict/delete', ids
    )
}
// 新增
// /stipulate/saveStipulate
export const saveStipulate = (row) => {
    return request.post(web.base +'/stipulate/saveStipulate', row
    )
}
export const findByChannelId = (channelId) => request({
    url: web.base +'/stipulate/findByChannelId',
    method: 'get',
    params: {
        channelId
    }
})